// extracted by mini-css-extract-plugin
module.exports = {"searchTriggerButton":"TopSearchModal_searchTriggerButton__DNB7K"};